import { MAX_TIMEOUT_DELAY } from "../../globals";
import { sleep } from "../../utils";
import { DialogService } from "./DialogModalService";
import { i18n } from "./I18nManager";
import { createHttpClient } from "./core/httpClient";

const UNAUTHORIZED_STATUS_CODE = 401;

const client = createHttpClient({
    onAuthRedirect: async (data) => {
        location.replace(data.url);
        await sleep(MAX_TIMEOUT_DELAY); //wait for reload
    },
    onError: async (error, response, route) => {
        await onNetworkError(error, response, route);
        return true;
    },
});

export const GET_REQUEST = client.GET_REQUEST;
export const POST_REQUEST = client.POST_REQUEST;
export const DELETE_REQUEST = client.DELETE_REQUEST;
export const PUT_REQUEST = client.PUT_REQUEST;
export const INTERNAL_SERVER_ERR_STATUS_CODE = client.INTERNAL_SERVER_ERR_STATUS_CODE;

export const invokeHTTPRequest = client.invokeHTTPRequest;

async function onNetworkError(error, response, route) {
    if (error && error.statusCode === UNAUTHORIZED_STATUS_CODE && !route.includes('authenticate')) {
        await showErrorDialog(i18n.translate('network.timeout.title'), i18n.translate('network.timeout.msg'));
    } else if (!response && location.pathname.startsWith('/app/') && !location.pathname.startsWith('/app/login') && !i18n.getCurrentAppConfig().disableNetworkPopus) {
        await showErrorDialog(i18n.translate('network.disconnected.title'), i18n.translate('network.disconnected.msg'));
    }
    return true;
}

async function showErrorDialog(title, msg) {
    DialogService.show(title, msg, logout, logout);
    await sleep(MAX_TIMEOUT_DELAY); // we don't want to see the child app msg along with FW
}

function logout() {
    location.pathname = '';
    location.reload();
}
